module.exports = __webpack_public_path__ + "img/edu-header.00b445c7.png";